module.exports = require("addons-linter");


//////////////////
// WEBPACK FOOTER
// external "addons-linter"
// module id = 167
// module chunks = 0